<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title">C<span class="smallcaps">ONTENTS</span></h1>
<p class="toc-fm"><a href="#/006_Dearreader#fm-1"><em>Dear Reader</em></a></p>
<p class="toc-chap-t"><a href="#/007_Chapter01#ch-1"><span class="num">1.</span> Imagination for Reading</a></p>
<p class="toc-chap"><span href="#/008_Chapter02#ch-2" title="Link target outside of Sample"><span class="num">2.</span> Vision for Theology</span></p>
<p class="toc-chap"><span href="#/009_Chapter03#ch-3" title="Link target outside of Sample"><span class="num">3.</span> Reading as Inhabitation</span></p>
<p class="toc-chap"><span href="#/010_Chapter04#ch-4" title="Link target outside of Sample"><span class="num">4.</span> Settings of Theology: Behind the Page</span></p>
<p class="toc-chap"><span href="#/011_Chapter05#ch-5" title="Link target outside of Sample"><span class="num">5.</span> Sources of Theology: Of the Page</span></p>
<p class="toc-chap"><span href="#/012_Chapter06#ch-6" title="Link target outside of Sample"><span class="num">6.</span> Architectures of Theology: Of the Page</span></p>
<p class="toc-chap"><span href="#/013_Chapter07#ch-7" title="Link target outside of Sample"><span class="num">7.</span> Invitations of Theology: In Front of the Page</span></p>
<p class="toc-bm-t"><span href="#/014_Send#bm-1" title="Link target outside of Sample"><em>Sending</em></span></p>
<p class="toc-bm"><span href="#/015_Ack#bm-2" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc-bm"><span href="#/016_Apendix#bm-3" title="Link target outside of Sample"><em>Appendix</em></span></p>
<p class="toc-bm"><span href="#/017_Endnotes#bm-4" title="Link target outside of Sample"><em>Notes</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?09d05aa2